import {
  Hook,
  LDClient,
  LDContext,
  LDEvaluationDetail,
  LDFlagSet,
  LDFlagValue,
} from 'launchdarkly-js-client-sdk';

import { FF_DASHBOARD_NOTIFICATION_SETTINGS } from '@/data/featureFlags';

const createArrayMockFeatureFlag = (value: boolean): readonly string[] => {
  // If enabled, return ['*'] to enable for all integrators/users
  if (value) {
    return ['*'];
  }
  return [];
};

const enable = (key: string, environmentValue: string): LDFlagSet => {
  return {
    [key]: {
      integrators: createArrayMockFeatureFlag(environmentValue === 'true'),
      users: createArrayMockFeatureFlag(environmentValue === 'true'),
    },
  };
};

const { VITE_LAUNCHDARKLY_NOTIFICATION_SETTINGS } = import.meta.env;

export class MockLDClient implements LDClient {
  private static VARIATIONS: LDFlagSet = {
    ...enable(FF_DASHBOARD_NOTIFICATION_SETTINGS, VITE_LAUNCHDARKLY_NOTIFICATION_SETTINGS),
  };

  addHook(_: Hook): void {}

  allFlags(): LDFlagSet {
    return {};
  }

  close(_?: () => void): Promise<void> {
    return Promise.resolve(undefined);
  }

  flush(_?: () => void): Promise<void> {
    return Promise.resolve(undefined);
  }

  getContext(): LDContext {
    return {} as LDContext;
  }

  identify(_context: LDContext, _hash?: string): Promise<LDFlagSet> {
    return Promise.resolve({});
  }

  off(_key: string, _callback: (...args: any[]) => void, _context?: LDContext): void {}

  on(_key: string, _callback: (...args: any[]) => void, _context?: LDContext): void {}

  setStreaming(_value?: boolean): void {}

  track(_key: string, _data?: any, _metricValue?: number): void {}

  /*
   * This is the only method that we really need to implement. Because
   * we want to return a value when we try to get the variation of a given flag
   * without calling LD API.
   */
  variation(key: string, defaultValue?: LDFlagValue): LDFlagValue {
    return MockLDClient.VARIATIONS[key] ?? defaultValue ?? false;
  }

  variationDetail(_key: string, _defaultValue?: LDFlagValue): LDEvaluationDetail {
    return {} as LDEvaluationDetail;
  }

  waitForInitialization(_timeout?: number): Promise<void> {
    return Promise.resolve(undefined);
  }

  waitUntilGoalsReady(): Promise<void> {
    return Promise.resolve(undefined);
  }

  waitUntilReady(): Promise<void> {
    return Promise.resolve(undefined);
  }
}
